var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu"},[_c('nav',[_c('router-link',{staticClass:"nav-item",attrs:{"to":{ name: 'Partners'}}},[_vm._v("Отчеты")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }